// recursive path calculator
function add(headers, format, path) {
    // format must be an object
    if (typeof format !== "object") return;
    // check properties
    for (const i in format) {
        if (!format[i]) continue;
        // if it is a vuetiform style component
        if (format[i].is) {
            // create the object that we will add to the array
            let o = {};
            o.text = format[i].label || i;
            o.value = path.concat([i]).join(".");
            if (format[i].table === null) continue;
            if (format[i].table) headers.push({ ...o, ...format[i].table });
            else headers.push(o);
            // the path is an array with the properties of the format
        } else add(headers, format[i], path.concat([i]));
    }
}

export default function headersByFormat(format) {
    // result array
    let headers = [];
    add(headers, format, []);
    return headers;
}
